import React from 'react'

const InterviewInviteTable = ({
    InterviewInvite,
    
}) => {
    return (
        <div className="appointment-details">
            <div className="details_row">
                <h2>Date/Time:</h2>
                <h3>{InterviewInvite?.datetime || 'N/A'}</h3>
            </div>
            <div className="details_row">
                <h2>Client:</h2>

                <h3>{InterviewInvite?.subclient ? InterviewInvite?.subclient?.name : InterviewInvite?.accounts?.user?.name || 'N/A'}</h3>



            </div>
            <div className="details_row">
                <h2>Facility:</h2>
                <h3>{InterviewInvite?.appointment_details?.facility?.abbreviation || 'N/A'}</h3>
            </div>
            <div className="details_row">
                <h2>Department:</h2>
                <h3>{InterviewInvite?.appointment_details?.department?.name || 'N/A'}</h3>
            </div>
            {/* <div className="details_row">
                <h2>Gender:</h2>
                <h3>{InterviewInvite?.gender || 'N/A'}</h3>
            </div> */}
            <div className="details_row">
                <h2>Type:</h2>
                <h3>{InterviewInvite?.type || 'N/A'}</h3>
            </div>
            <div className="details_row">
                <h2>Video link:</h2>
                <h3>{InterviewInvite?.appointment_details?.video_link || 'N/A'}</h3>
            </div>
            <div className="details_row">
                <h2>Language:</h2>
                <h3>{InterviewInvite?.language?.name || 'N/A'}</h3>
            </div>
        </div>
    )
}

export default InterviewInviteTable